declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
    js3q?: any;
    UC_UI?: any;
  }
}

export const js3q = ({ dataid, container }) => ({
  video: undefined,
  interval: undefined,
  dialog: {
    show: false,
    consent: false,
    init: false,
  },

  openDialog() {
    this.dialog.show = true;
    this.dialog.init = true;

    if (!this.dialog.consent) return;

    if (this.video) {
      this.video.enableControls();
      this.video.play();
    } else {
      if (window.js3q) {
        if (this.interval) clearInterval(this.interval);
        const videoInstance = new window.js3q({
          dataid,
          container,
          autoplay: true,
          controls: true,
        });
        this.video = videoInstance;
        this.video.on('media.playing', () => {
          this.trackEconda('playing');
        });
        this.video.on('media.paused', () => {
          const length = this.video.getVideoInfo().Length.toFixed();
          const currentTime = this.video.getCurrentTime().toFixed();
          if (length !== currentTime) this.trackEconda('paused');
        });
        this.video.on('media.complete', () => {
          this.trackEconda('stopped');
        });
      }
    }
  },
  closeDialog() {
    this.dialog.show = false;
    if (this.video) {
      this.video.pause();
    }
  },

  /** Open Usercentrics UI and display 3Q-Player details. */
  moreInfo() {
    window.UC_UI?.showSecondLayer('qxiCD5aN_');
  },

  /** Accepts Usercentrics 3Q-Player. */
  accept() {
    window.UC_UI?.acceptService('qxiCD5aN_');
  },

  init() {
    window.addEventListener('ucEvent', (e: any) => {
      if (e.detail && e.detail.event === 'consent_status') {
        if (e.detail['3Q Video'] === true) {
          this.dialog.consent = true;
        } else {
          this.dialog.consent = false;
          if (this.interval) clearInterval(this.interval);
          this.video = undefined;
        }
      }
    });
  },

  trackEconda(state: 'playing' | 'paused' | 'stopped') {
    const videoInfo = this.video.getVideoInfo();
    const currentTime = this.video.getCurrentTime();
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'RichMedia',
      event_name: 'rich_media',
      content: {
        name: videoInfo.Metadata.Title,
        category: 'Sonstiges Video',
      },
      type: 'video',
      duration: videoInfo.Length,
      previewUri: dataid,
      state: [state, currentTime],
    });
  },
});
